import React from 'react';
import {Chip, CircularProgress} from '@mui/material';
import {useGetTraceJourneeQuery} from '../../../modules/simulations/simulations.api';
import {traceDeLEquipe} from './atelierRules';

/**
 * Lot 8 : pilule d'une journée, « routier » ou « vol d'oiseau », selon la méthode du tracé annoncée par l'API. La requête est
 * partagée avec la carte (même cache RTK Query). `currentData` : jamais la méthode d'une autre journée pendant le chargement.
 * Requête en échec : la carte garde ses lignes droites, donc « vol d'oiseau ». Rien à qualifier (moins de deux points) : pas de pilule.
 */
function PiluleTrace({simulationId, date, equipe, sx}) {
    const {currentData, isFetching, isError} = useGetTraceJourneeQuery({id: simulationId, date});
    if (isFetching) return <CircularProgress size={12} aria-label="Calcul du tracé" sx={{flex: 'none', ...sx}}/>;
    const trace = isError ? {methode: 'vol_oiseau', libelle: "vol d'oiseau", routier: false} : traceDeLEquipe(currentData, equipe);
    if (!trace || (!isError && trace.positions.length < 2)) return null;
    return (
        <Chip size="small" label={trace.libelle} data-testid="pilule-trace" data-methode={trace.methode}
              sx={{flex: 'none', height: 18, fontSize: 11, fontWeight: 700, bgcolor: trace.routier ? '#E7ECF6' : '#FDEBD8', color: trace.routier ? '#0F2D69' : '#B8641A', ...sx}}/>
    );
}

export default PiluleTrace;
